import { createFileRoute, Outlet, useNavigate, useLocation } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/lib/auth-context";

export const Route = createFileRoute("/_authenticated")({
  component: AuthGuard,
});

function AuthGuard() {
  const { user, loading, isAdmin, aal, nextAal, mustChangePassword } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    if (loading) return;
    
    if (!user) {
      window.location.href = '/login.html';
      return;
    }

    if (mustChangePassword && loc.pathname !== "/change-password") {
      navigate({ to: "/change-password" });
      return;
    }

    // Skip MFA checks for now (aal is always aal2 in simplified auth)
  }, [user, loading, isAdmin, aal, nextAal, mustChangePassword, loc.pathname, navigate]);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Chargement…</div>;
  }

  if (!user) {
    return null;
  }

  return <Outlet />;
}
